/* Honey & Paw — honey rewards.
   1) Honey-drip: a short honey drip animation when an add-to-cart button is pressed.
   2) Accrual: a front-end honey-points balance (localStorage), grown on each add-to-cart and
      shown in the header chip + a "+N honey" toast.
   NOTE: this is the FRONT-END mechanic. Real, redeemable points tied to completed orders (and
   shared across devices / a customer account) need a loyalty app (Smile.io, LoyaltyLion) or a
   customer-metafield backend updated on order creation. Swap getBal/setBal for that when ready. */
(function () {
  var KEY = 'hp_honey_points';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // A logged-in customer's chip is server-rendered from the real customer.loyalty.honey_points
  // metafield. Guests get a local demo balance. Never let local state overwrite the real one.
  function loggedIn() { return !!document.querySelector('[data-honey-chip][data-honey-real]'); }

  function getBal() { try { return parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; } }
  function setBal(v) { try { localStorage.setItem(KEY, v); } catch (e) {} updateChips(v); }

  function updateChips(v) {
    if (loggedIn()) return; // real balance is authoritative; rendered in Liquid
    document.querySelectorAll('[data-honey-chip]').forEach(function (el) { el.hidden = true; });
    return; // guests never see a demo balance
    if (v == null) v = getBal();
    document.querySelectorAll('[data-honey-balance]').forEach(function (el) { el.textContent = v.toLocaleString(); });
    document.querySelectorAll('[data-honey-chip]').forEach(function (el) { el.hidden = v <= 0; });
  }

  function rate() {
    var earn = document.querySelector('.hp-honey-earn[data-honey-rate]');
    return earn ? (parseFloat(earn.getAttribute('data-honey-rate')) || 10) : 10;
  }
  function qtyFor(btn) {
    var form = btn.closest('form, product-form');
    var q = form && form.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function pointsFor(btn) {
    // PDP: read the live honey-earn value
    var earn = document.querySelector('.hp-honey-earn[data-honey-pts-val]');
    if (earn && btn.closest('product-form, .hp-buybox, .product, #MainContent .product')) {
      var v = parseInt(earn.getAttribute('data-honey-pts-val'), 10);
      if (v) return v * qtyFor(btn);
    }
    // card / quick-view: parse a nearby price
    var scope = btn.closest('.card-wrapper, .hp-qv-modal, .product-card-wrapper');
    var priceEl = scope && scope.querySelector('.hp-price__now, .hp-qv-price .now, .price-item--regular');
    if (priceEl) {
      var num = parseFloat((priceEl.textContent || '').replace(/[^0-9.]/g, ''));
      if (!isNaN(num)) return Math.floor(num * rate());
    }
    return 0;
  }

  var BEAR =
    '<svg viewBox="0 0 64 80" fill="none" aria-hidden="true">' +
      '<defs><linearGradient id="__UID__" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0" stop-color="#F7C24E"/><stop offset="1" stop-color="#E0982C"/>' +
      '</linearGradient></defs>' +
      '<rect x="28.5" y="0" width="7" height="5" rx="1.5" fill="#0E6157"/>' +
      '<rect x="26" y="4" width="12" height="8" rx="2.5" fill="#0E6157"/>' +
      '<circle cx="20" cy="20" r="6.5" fill="url(#__UID__)"/>' +
      '<circle cx="44" cy="20" r="6.5" fill="url(#__UID__)"/>' +
      '<circle cx="32" cy="25" r="15" fill="url(#__UID__)"/>' +
      '<path d="M14 56C14 40 22 34 32 34s18 6 18 22c0 14-8 20-18 20S14 70 14 56Z" fill="url(#__UID__)"/>' +
      '<circle cx="12" cy="50" r="7" fill="url(#__UID__)"/>' +
      '<circle cx="52" cy="50" r="7" fill="url(#__UID__)"/>' +
      '<ellipse cx="32" cy="57" rx="11" ry="14" fill="#FCEBC4" opacity="0.5"/>' +
      '<circle cx="26" cy="24" r="2" fill="#5A3210"/>' +
      '<circle cx="38" cy="24" r="2" fill="#5A3210"/>' +
      '<ellipse cx="32" cy="30" rx="4.2" ry="3.2" fill="#FCEBC4"/>' +
      '<circle cx="32" cy="28.6" r="1.5" fill="#5A3210"/>' +
    '</svg>';

  function drip(btn) {
    if (reduce) return;
    if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
    btn.style.overflow = 'visible';
    var uid = 'hb' + Math.random().toString(36).slice(2, 8);
    var bear = document.createElement('span');
    bear.className = 'hp-honeybear';
    bear.setAttribute('aria-hidden', 'true');
    bear.innerHTML =
      BEAR.replace(/__UID__/g, uid) +
      '<span class="hp-honeybear__stream"></span>' +
      '<span class="hp-honeybear__drop hp-honeybear__drop--1"></span>' +
      '<span class="hp-honeybear__drop hp-honeybear__drop--2"></span>';
    btn.appendChild(bear);
    setTimeout(function () { bear.remove(); }, 1800);
  }

  function toast(pts) {
    if (pts <= 0) return;
    var t = document.createElement('div');
    t.className = 'hp-honey-toast';
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5c3 4.6 6 7.8 6 11.4a6 6 0 0 1-12 0c0-3.6 3-6.8 6-11.4z"/></svg> +' + pts.toLocaleString() + ' honey';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 350); }, 2200);
  }

  function addBtn(target) {
    return target.closest('[name="add"], .hp-sticky-atc__btn, .quick-add__submit, .hp-qv-add, .hp-mm__add, .hp-bundle-card__btn');
  }

  document.addEventListener('click', function (e) {
    var btn = addBtn(e.target);
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    drip(btn);
    // Guests get the animation only. The demo localStorage balance and '+N honey' toast were a
    // promise with no redemption behind it (removed 2026-09-02). Logged-in customers with a real
    // customer.loyalty.honey_points metafield keep their server-rendered chip.
    if (!loggedIn()) return;
    var pts = pointsFor(btn);
    if (pts > 0) {
      toast(pts);
      // Guests accrue a local demo balance. Logged-in customers earn for real when the order is
      // paid (accrual updates the metafield server-side), so we don't optimistically bump theirs.
      if (!loggedIn()) setBal(getBal() + pts);
    }
  }, true);

  if (document.readyState !== 'loading') updateChips();
  else document.addEventListener('DOMContentLoaded', function () { updateChips(); });
  document.addEventListener('shopify:section:load', function () { updateChips(); });
})();
